// @ts-nocheck

import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { SingleDatePicker } from 'react-dates'
import { connect } from 'react-redux'
import Actions from '../../../actions'

class SingleDateSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      focused: false
    }
    this.nextDate = this.nextDate.bind(this)
    this.prevDate = this.prevDate.bind(this)
  }

  componentDidMount() {
    const date = moment()
    this.props.setTodosDate(date)
  }

  nextDate() {
    const { currentDate, onChange } = this.props
    const nextDate = moment(currentDate).add(1, 'd')
    onChange(nextDate)
  }

  prevDate() {
    const { currentDate, onChange } = this.props
    const prevDate = moment(currentDate).subtract(1, 'd')
    onChange(prevDate)
  }

  render() {
    const { currentDate, onChange } = this.props
    const { focused } = this.state
    return (
      <span>
        <span style={styles.button} onClick={this.prevDate}>
          <LeftOutlined />
        </span>
        <SingleDatePicker
          // displayFormat allows the specification of the date
          // format. Default is MMM D.
          displayFormat={this.props.displayFormat || 'MMM D'}
          isOutsideRange={() => false}
          hideKeyboardShortcutsPanel
          date={currentDate}
          onDateChange={onChange}
          focused={focused}
          onFocusChange={({ focused }) => this.setState({ focused })}
          id="lmc_single_date_picker"
        />
        <span style={styles.button} onClick={this.nextDate}>
          <RightOutlined />
        </span>
      </span>
    )
  }
}

const styles = {
  button: {
    padding: '6px 8px 10px 8px',
    cursor: 'pointer'
  }
}

SingleDateSelector.propTypes = {
  currentDate: PropTypes.object,
  onChange: PropTypes.func,
  setTodosDate: PropTypes.func.isRequired
}

const mapStatetoProps = (state, props) => {
  return {
    currentDate: props.currentDate || state.todos.currentDate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setTodosDate: (date) => dispatch(Actions.setTodosDate(date))
  }
}

export default connect(mapStatetoProps, mapDispatchToProps)(SingleDateSelector)
